import * as React from 'react';

import cn from 'classnames';

import { player, EPlayerEvent } from '@modules';

import { Icon } from '@components/Icon';

import { IconPause, IconPlay } from '@icons';

import { IPlayButtonProps, IPlayButtonState } from './types';

import * as s from './PlayButton.scss';

export class PlayButton extends React.Component<IPlayButtonProps, IPlayButtonState> {

	state: IPlayButtonState = {
		isPlay: false,
	};

	componentDidMount(): void {
		player.on(EPlayerEvent.PLAY, this.onPlay);
		player.on(EPlayerEvent.PAUSE, this.onPause);
	}

	componentWillUnmount(): void {
		player.off(EPlayerEvent.PLAY, this.onPlay);
		player.off(EPlayerEvent.PAUSE, this.onPause);
	}

	onClick = () => {
		player.toggle();
	};

	onPlay = () => {
		this.setState({ isPlay: true });

		this.props.onPlay && this.props.onPlay();
	};

	onPause = () => this.setState({ isPlay: false });

	render() {
		const { className } = this.props;
		const { isPlay } = this.state;

		return (
			<button className={cn(s.block, className)} onClick={this.onClick}>
				{isPlay
					? <Icon className={s.icon} glyph={IconPause} />
					: <Icon className={s.icon} glyph={IconPlay} />
				}
			</button>
		);
	}

}
